export default (el, _, { cleanup }) => {
  const banner = el.firstElementChild;

  const spacer = document.createElement('div');
  spacer.style.height = `${banner.getBoundingClientRect().height}px`;
  spacer.classList.add('hidden');
  el.appendChild(spacer);

  const onScroll = () => {
    const stick = el.getBoundingClientRect().top < 0;
    banner.classList.toggle('fixed', stick);
    spacer.classList.toggle('hidden', !stick);
  };

  window.addEventListener('scroll', onScroll);
  cleanup(() => window.removeEventListener('scroll', onScroll));
};
